import Backbone from 'backbone';
import {useCallback} from 'react';
import {useSyncExternalStore} from 'use-sync-external-store/shim';

import preferences from 'Preferences';

/**
 * Custom React hook to read and write from a user preference.
 *
 * If a default value is not been set for a preference, the caller is responsible for unioning
 * the value type with undefined when specifying T.
 */
export default function usePreference<T>(preferenceName: string): [T, (pref: T) => void] {
  const subscribe = useCallback(
    (callback) => {
      const event = `change:${preferenceName}`;
      (preferences as unknown as Backbone.Events).on(event, callback);
      return () => {
        (preferences as unknown as Backbone.Events).off(event, callback);
      };
    },
    [preferenceName]
  );
  const setPreferenceValue = useCallback(
    (value) => {
      preferences.set(preferenceName, value);
    },
    [preferenceName]
  );

  const preferenceValue = useSyncExternalStore<T>(subscribe, () => preferences.get(preferenceName));

  return [preferenceValue, setPreferenceValue];
}
